import { render, staticRenderFns } from "./HomeNotify.vue?vue&type=template&id=a1e813a6&scoped=true&"
import script from "./HomeNotify.vue?vue&type=script&lang=js&"
export * from "./HomeNotify.vue?vue&type=script&lang=js&"
import style0 from "./HomeNotify.vue?vue&type=style&index=0&id=a1e813a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e813a6",
  null
  
)

export default component.exports